import React, {Component, useState, useEffect, useCallback, useRef, useLayoutEffect} from 'react';
import { createPortal } from 'react-dom';

import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';

import IconSmoothen from '../icons/toolbar/menu/retouch/Smoothen';
import IconWhiten from '../icons/toolbar/menu/retouch/Whiten';
import IconErase from '../icons/toolbar/menu/retouch/Erase';
import IconPatch from '../icons/toolbar/menu/retouch/Patch';

const TOOLS = [
  {
    id: 0,
    icon: <IconSmoothen />,
    title: 'Smoothen',
    key: 'smoothen',
    show: true,
  },
  {
    id: 1,
    icon: <IconWhiten />,
    title: 'Whiten',
    key: 'whiten',
    show: true,
  },
  {
    id: 2,
    icon: <IconErase />,
    title: 'Erase',
    key: 'erase',
    show: true,
  },
  {
    id: 3,
    icon: <IconPatch />,
    title: 'Patch',
    key: 'patch',
    show: false,
  },
];

const RetouchControls = ({ state, onSelected, onCancel, onApply }) => {

  const [controlPanelElement, setControlPanelElement] = useState(null)
  const [controlPanel, setControlPanel] = useState(null)
  const [selectedTool, setSelectedTool] = useState(null)

  useLayoutEffect(() => {
    let element = document.getElementById(`${state.currentTab}-controls`)
    setControlPanelElement(element)
  }, [state.currentTab])

  useEffect(() => {
    if(!controlPanelElement){
      return null
    }
    setControlPanel(createPortal(_renderContent(), controlPanelElement))
  }, [controlPanelElement, selectedTool])

  function _renderContent(){
    return (
      <Tab.Container activeKey={selectedTool?.key}>
        <Tab.Content className="adjust-contents">
          {_renderTabs()}
        </Tab.Content>
        <div className="menu">
          <Nav variant="" className="flex-nowrap" justify>
            {_renderControls()}
          </Nav>
        </div>

      </Tab.Container>
    )
  }

  function _renderTabs(){
    return TOOLS.map(tool => {
      return (
        <Tab.Pane key={tool.key} eventKey={tool.key}>
          {tool.title}
        </Tab.Pane>
      );
    });
  }

  function _renderControls(){
    return TOOLS.map((tool, index) => {
      if (!tool.show) {
        return null;
      }
      return (
        <Nav.Item
          key={tool.key}
          onClick={() => {
            if(selectedTool?.key == tool.key){
              onCancel(tool.key)
              setSelectedTool(null)
            }else{
              onSelected(tool.key)
              setSelectedTool(tool)
            }
          }}>
          <Nav.Link key={tool.key} eventKey={tool.key}>
            {tool.icon}
          </Nav.Link>
        </Nav.Item>
      );
    });
  }

  return controlPanel
}

export default RetouchControls;
